// extracted by mini-css-extract-plugin
export default {"menu":"Xbp096","menuItem":"ZnviBD","icon":"_C8PsH","login":"iBqmGt","home":"C5EtmR","bgm":"eiZk5u","off":"FBuBZt"};